var styles = {"box":"ArcPseudoBg_box_11b5q_1","active":"ArcPseudoBg_active_11b5q_28","v2":"ArcPseudoBg_v2_11b5q_34"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
